import Yup from "../../helpers/customValidation";
let validationSchema = Yup.object({
  name: Yup.string().required("Name is Required"),
  email: Yup.string("Email is Required")
    .email("Email Must be Unique")
    .required("Email is Required"),
});

export { validationSchema };
